import {Injectable} from '@angular/core';
import {GeneralServicesImplService} from '../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProjectConstants} from '../../project-constants';
import {UserModel} from '../../../models/UserModel';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends GeneralServicesImplService {
  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.users;
  baseUrl: string = servers.apiUrl + urls.users;

  private _editUser: UserModel;
  get editUser() { return this._editUser; }
  set editUser(user) { this._editUser = user; }

  constructor(http: HttpClient) {
    super(http);
  }

  getPage(offset: any, filter?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body = filter ? JSON.stringify(filter) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post(url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  softDelete(id: number): Observable<any> {
    const url = this.baseUrl + this.LINKS.SOFT_DELETE + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map(data => data)
      );
  }

  getUserSectionGrant(userId: number, sectionId: string): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_USER_SECTION_GRANT + '/' + sectionId + '/' + userId;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post(url, null, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  updateAllClaims(offset: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.UPDATE_USERS_ACCESS;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

}
